/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'detectedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'calculatedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'colorGradation'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'heightMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'widthMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum];


